var _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiPlantCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--plant-check_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--plant-check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21v-7.975a7.942 7.942 0 01-3.075-.613A7.956 7.956 0 013.6 8.075C3.2 7.092 3 6.067 3 5V3h2a7.88 7.88 0 013.05.612c.983.409 1.85.988 2.6 1.738a7.62 7.62 0 011.287 1.7c.342.617.605 1.275.788 1.975.083-.117.175-.23.275-.338.1-.108.208-.22.325-.337a7.957 7.957 0 012.6-1.737A7.941 7.941 0 0119 6h2v2a7.942 7.942 0 01-.613 3.075 7.956 7.956 0 01-1.737 2.6 7.827 7.827 0 01-2.587 1.725c-.975.4-1.996.6-3.063.6v5h-2zm0-10c0-.8-.154-1.563-.463-2.287a6.087 6.087 0 00-1.312-1.938 6.088 6.088 0 00-1.938-1.313A5.785 5.785 0 005 5c0 .8.15 1.567.45 2.3.3.733.733 1.383 1.3 1.95.567.567 1.217 1 1.95 1.3.733.3 1.5.45 2.3.45zm2 3a5.924 5.924 0 004.225-1.75 6.05 6.05 0 001.313-1.95C18.846 9.567 19 8.8 19 8c-.8 0-1.567.154-2.3.463a6.05 6.05 0 00-1.95 1.312A5.918 5.918 0 0013 14z",
    fill: "#000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 23.25l3.525-3.55-.7-.7-2.825 2.825-1.425-1.425-.7.725L20.3 23.25zM21 26c-1.383 0-2.563-.488-3.538-1.462C16.488 23.562 16 22.383 16 21s.488-2.563 1.462-3.538C18.438 16.488 19.617 16 21 16s2.563.488 3.538 1.462C25.512 18.438 26 19.617 26 21s-.488 2.563-1.462 3.538C23.562 25.512 22.383 26 21 26z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--plant-check-a7f79388fb1a911a2621b901401f31f2.svg";
export { SvgIconUiPlantCheck as Component };